module.exports = __webpack_public_path__ + "static/media/newOrder.676cb867.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/newOrder.mp3
// module id = 1344
// module chunks = 0